import { Pipe, PipeTransform } from '@angular/core';
import { InspectionEntryDetailDto } from '@artemis-software/wr-api';
import { EnumTranslationPipe } from './enum-translation.pipe';

const LABELS: Record<InspectionEntryDetailDto.DeadlineEnum, string> = {
  NONE: 'Keine Frist',
  TEN_DAYS: '10 Tage',
  ONE_MONTH: '1 Monat',
  HALF_YEAR: '6 Monate',
  YEAR: '1 Jahr',
};

@Pipe({
  standalone: false,
  name: 'deadlineTranslation',
})
export class DeadlineTranslationPipe implements EnumTranslationPipe<InspectionEntryDetailDto.DeadlineEnum | null | undefined>, PipeTransform {

  transform(value: InspectionEntryDetailDto.DeadlineEnum | null | undefined): string {
    if (!value) {
      return '–';
    }
    const label = LABELS[value];
    if (!label) {
      console.error(`Unknown deadline: ${value}`);
      return '–';
    }
    return label;
  }
}
